(() => {
  const root = document.querySelector('[data-eg-facets]');
  if (!root) return;
  const form = root.querySelector('[data-facet-form]');
  const dialog = root.querySelector('[data-facet-dialog]');
  const home = form.parentElement;
  const opener = root.querySelector('[data-facet-open]');
  const close = form.querySelector('[data-facet-close]');
  const mobile = matchMedia('(max-width: 900px)');
  const minimum = form.querySelector('[data-price-min]');
  const maximum = form.querySelector('[data-price-max]');
  const normal = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  const groups = Array.from(form.querySelectorAll('[data-facet-group]'));
  let submitting = false;
  const validatePrice = () => {
    if (!minimum || !maximum) return;
    const invalid = minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value);
    maximum.setCustomValidity(invalid ? form.dataset.invalidPrice : '');
  };
  const updateSelection = () => {
    let total = 0;
    groups.forEach(group => {
      const count = group.querySelectorAll('input[type=checkbox]:checked').length;
      group.querySelector('[data-facet-group-count]').textContent = count || '';
      total += count;
    });
    if ((minimum && minimum.value !== '') || (maximum && maximum.value !== '')) total += 1;
    form.querySelector('[data-facet-pending]').textContent = total ? ` (${total})` : '';
    validatePrice();
  };
  groups.forEach(group => {
    const list = group.querySelector('[data-facet-values]');
    const rows = Array.from(group.querySelectorAll('[data-facet-value]'));
    if (/facet_(volume|diameter|height|pack)$/.test(group.dataset.facetParam)) {
      const weight = row => {
        const label = row.querySelector('input').value;
        if (/^Do /i.test(label)) return 0;
        return Number((label.replace(/(\d)\s+(?=\d)/g, '$1').match(/[\d.,]+/) || ['0'])[0].replace(',', '.'));
      };
      rows.sort((a, b) => weight(a) - weight(b)).forEach(row => list.appendChild(row));
    }
    if (/consumable_size$/.test(group.dataset.facetParam)) {
      const collator = new Intl.Collator('sk', { numeric: true, sensitivity: 'base' });
      const garmentSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
      const compareSize = (a, b) => {
        const left = a.querySelector('input').value.trim();
        const right = b.querySelector('input').value.trim();
        const leftSize = garmentSizes.indexOf(left.toUpperCase());
        const rightSize = garmentSizes.indexOf(right.toUpperCase());
        if (leftSize !== -1 && rightSize !== -1) return leftSize - rightSize;
        const prefix = label => normal(label.split(/\d/)[0]).trim();
        if (prefix(left) === prefix(right)) {
          const numbers = label => (label.match(/\d+(?:[.,]\d+)?/g) || []).map(value => Number(value.replace(',', '.')));
          const leftNumbers = numbers(left);
          const rightNumbers = numbers(right);
          for (let i = 0; i < Math.min(leftNumbers.length, rightNumbers.length); i++) {
            if (leftNumbers[i] !== rightNumbers[i]) return leftNumbers[i] - rightNumbers[i];
          }
          if (leftNumbers.length !== rightNumbers.length) return leftNumbers.length - rightNumbers.length;
        }
        return collator.compare(left, right);
      };
      rows.sort(compareSize).forEach(row => list.appendChild(row));
    }
    const search = group.querySelector('[data-facet-search]');
    if (search) search.addEventListener('input', () => {
      const query = normal(search.value.trim());
      let visible = 0;
      rows.forEach(row => { row.hidden = !normal(row.querySelector('input').value).includes(query); if (!row.hidden) visible++; });
      group.querySelector('[data-facet-no-values]').hidden = visible !== 0;
    });
  });
  const restoreForm = () => {
    if (!submitting) {
      form.reset();
      form.querySelectorAll('[data-facet-value]').forEach(row => { row.hidden = false; });
      form.querySelectorAll('[data-facet-no-values]').forEach(note => { note.hidden = true; });
      updateSelection();
    }
    home.appendChild(form);
    document.body.classList.remove('eg-filters-open');
    if (mobile.matches) opener.focus();
  };
  if (typeof dialog.showModal === 'function') {
    root.classList.add('is-enhanced');
    opener.addEventListener('click', () => {
      if (!mobile.matches || dialog.open) return;
      dialog.appendChild(form);
      document.body.classList.add('eg-filters-open');
      dialog.showModal();
      close.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', restoreForm);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    mobile.addEventListener('change', () => { if (!mobile.matches && dialog.open) dialog.close(); });
  }
  form.addEventListener('input', updateSelection);
  form.addEventListener('submit', () => { submitting = true; });
  form.addEventListener('formdata', event => {
    for (const [key, value] of Array.from(event.formData.entries())) {
      if (key.startsWith('filter.') && value === '') event.formData.delete(key);
    }
  });
  root.querySelector('[data-facet-sort]').addEventListener('change', () => form.requestSubmit());
  window.addEventListener('pageshow', () => { submitting = false; });
  updateSelection();
})();
